import React, { useState, useEffect } from "react";
import { Fieldset } from "primereact/fieldset";
import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";
import { appConstantes, nemonicoTipoSolicitud } from "../../constantes/appConstantes";
import { useSelector } from "react-redux";
import RenderToast from "../../componentes/RenderToast";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  obtenerDetalleEntidad,
  setMessageError,
  setValidarDatos,
} from "../../sliceRedux/ValidarReserva.slice";
import moment from "moment";
import DownloadCroquis from "../../componentes/DownloadCroquis";
import Observation from "../../componentes/Observation";

const RevisarEntidadConstitución = (props) => {
  const {
    showLoader,
    hideLoader,
    dispatch,
    codSolReservaDenominacion,
    codSolConstitucion,
    setConstitucion,
    toast,
  } = props;
  const validarDatos = useSelector((state) => state.validar.validarDatos);
  const messageError = useSelector((state) => state.validar.messageError);
  const [detalleEntidad, setDetalleEntidad] = useState({});
  const [listaTelefonos, setListaTelefonos] = useState([]);

  useEffect(() => {
    showLoader();
    dispatch(obtenerDetalleEntidad(codSolReservaDenominacion, codSolConstitucion));
  }, []);

  useEffect(() => {
    if (validarDatos.code === 200) {
      setDetalleEntidad(validarDatos?.object?.solicitudReserva ?? {});
      setConstitucion(validarDatos?.object ?? {});
      setListaTelefonos(validarDatos?.object?.listContacto ?? []);
    }
    return () => {
      hideLoader();
      dispatch(setValidarDatos({ ...validarDatos, code: 0 }));
    };
  }, [validarDatos.code]);

  useEffect(() => {
    if (messageError != "") {
      RenderToast(toast, "error", "Error", messageError);
      hideLoader();
    }
    return () => {
      dispatch(setMessageError(""));
    };
  }, [messageError]);

  const rowIndexTemplate = (rowData, column) => {
    return column.rowIndex + 1 + "";
  };

  return (
    <>
      <div className="card">
        <Observation observationValue={validarDatos?.object?.observacion} />
        <Fieldset legend="Datos de la entidad">
          <div className="grid">
            <div className="col-12 md:col-12">
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="codigoReserva"
                  className="mr-2"
                  style={{ minWidth: "150px", textAlign: "left" }}
                  required
                >
                  Número solicitud de reserva:
                </label>
                <div className="col">
                  <InputText
                    id="codigoReserva"
                    name="codigoReserva"
                    value={detalleEntidad.numSolicitud ?? ""}
                    autoComplete="off"
                    disabled
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="razonSocial"
                  className="mr-2"
                  style={{ minWidth: "140px", textAlign: "left" }}
                  required
                >
                  Razón social:
                </label>
                <div className="col">
                  <InputText
                    id="razonSocial"
                    name="razonSocial"
                    value={
                      (detalleEntidad.nomCatTipoCaja ?? "").toUpperCase() +
                      " " +
                      (detalleEntidad.nomParticular ?? "").toUpperCase()
                    }
                    autoComplete="off"
                    disabled
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
            </div>
            <div className="col-12 md:col-6">
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="tipoCaja"
                  className="mr-2"
                  style={{ minWidth: "140px", textAlign: "left" }}
                  required
                >
                  Tipo de caja:
                </label>
                <div className="col">
                  <InputText
                    id="tipoCaja"
                    name="tipoCaja"
                    value={detalleEntidad.nomCatTipoCaja ?? ""}
                    autoComplete="off"
                    disabled
                    style={{ width: "100%" }}
                  />
                </div>
              </div>

              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="provincia"
                  className="mr-2"
                  style={{ minWidth: "140px", textAlign: "left" }}
                  required
                >
                  Provincia:
                </label>
                <div className="col">
                  <InputText
                    id="provincia"
                    name="provincia"
                    value={detalleEntidad.nomAmbGeoProvincia ?? ""}
                    disabled
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="canton"
                  className="mr-2"
                  style={{ minWidth: "140px", textAlign: "left" }}
                  required
                >
                  Cantón:
                </label>
                <div className="col">
                  <InputText
                    id="canton"
                    name="canton"
                    value={detalleEntidad.nomAmbGeoCanton ?? ""}
                    disabled
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="parroquia"
                  className="mr-2"
                  style={{ minWidth: "140px", textAlign: "left" }}
                  required
                >
                  Parroquia:
                </label>
                <div className="col">
                  <InputText
                    id="parroquia"
                    name="parroquia"
                    value={detalleEntidad.nomAmbGeoParroquia ?? ""}
                    disabled
                    style={{ width: "100%" }}
                  />
                </div>
              </div>

              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="barrio"
                  className="mr-2"
                  style={{ minWidth: "140px", textAlign: "left" }}
                  required
                >
                  Barrio / Ciudadela:
                </label>
                <div className="col">
                  <InputText
                    id="barrio"
                    name="barrio"
                    value={validarDatos?.object?.barrioCiudadela ?? ""}
                    autoComplete="off"
                    disabled
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="email"
                  className="mr-2"
                  style={{ minWidth: "140px", textAlign: "left" }}
                  required
                >
                  Correo electrónico:
                </label>
                <div className="col">
                  <InputText
                    id="email"
                    name="email"
                    value={validarDatos?.object?.correo ?? ""}
                    autoComplete="off"
                    disabled
                    style={{ width: "100%" }}
                  />
                </div>
              </div>

              <DataTable
                value={listaTelefonos}
                emptyMessage={appConstantes.SIN_DATOS}
                paginator
                rows={3}
              >
                <Column
                  body={rowIndexTemplate}
                  header="Nro."
                  headerStyle={{ textAlign: "center" }}
                  style={{ width: "3%" }}
                  bodyStyle={{
                    textAlign: "center",
                  }}
                />
                <Column field="nomTipoContacto" header="Tipo" sortable />
                <Column field="contacto" header="Número" sortable />
              </DataTable>
            </div>
            <div className="col-12 md:col-6">
              <div className="flex col-12 md:col-12">
                <label
                  htmlFor="tipoVinculo"
                  className="mr-2"
                  style={{ minWidth: "110px", textAlign: "left" }}
                  required
                >
                  Tipo de vínculo común:
                </label>
                <div className="col">
                  <InputText
                    id="tipoVinculo"
                    name="tipoVinculo"
                    value={detalleEntidad.nomVinculoComun ?? ""}
                    autoComplete="off"
                    disabled
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-12">
                <label
                  htmlFor="vinculoComun"
                  className="mr-2"
                  style={{ minWidth: "110px", textAlign: "left" }}
                  required
                >
                  Vínculo común:
                </label>
                <div className="col">
                  <InputTextarea
                    id="vinculoComun"
                    name="vinculoComun"
                    disabled
                    value={validarDatos?.object?.descVincComun ?? ""}
                    autoComplete="off"
                    rows={3}
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-12">
                <label
                  htmlFor="callePrincipal"
                  className="mr-2"
                  style={{ minWidth: "110px", textAlign: "left" }}
                  required
                >
                  Calle principal:
                </label>
                <div className="col">
                  <InputTextarea
                    id="callePrincipal"
                    name="callePrincipal"
                    value={detalleEntidad.nomCallePrincipal ?? ""}
                    autoComplete="off"
                    rows={2}
                    disabled
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-12">
                <label
                  htmlFor="calleSecundaria"
                  className="mr-2"
                  style={{ minWidth: "110px", textAlign: "left" }}
                  required
                >
                  Calle secundaria:
                </label>
                <div className="col">
                  <InputTextarea
                    id="calleSecundaria"
                    name="calleSecundaria"
                    value={detalleEntidad.nomCalleSecundaria ?? ""}
                    autoComplete="off"
                    rows={2}
                    disabled
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-8">
                <label
                  htmlFor="numero"
                  className="mr-2"
                  style={{ minWidth: "110px", textAlign: "left" }}
                >
                  Número:
                </label>
                <div className="col">
                  <InputText
                    id="numero"
                    name="numero"
                    value={detalleEntidad.txtNumero ?? ""}
                    autoComplete="off"
                    disabled
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-12">
                <label
                  htmlFor="parroquia"
                  className="mr-2"
                  style={{ minWidth: "110px", textAlign: "left" }}
                >
                  Referencia:
                </label>
                <div className="col">
                  <InputTextarea
                    id="referencia"
                    name="referencia"
                    rows={3}
                    disabled
                    value={detalleEntidad.txtReferencia ?? ""}
                    autoComplete="off"
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
              <DownloadCroquis
                showLoader={showLoader}
                hideLoader={hideLoader}
                codSolicitud={codSolReservaDenominacion}
                dispatch={dispatch}
                toast={toast}
              />
            </div>
          </div>
        </Fieldset>
        <div className="m-3"></div>
        <Fieldset legend="Datos asamblea constitutiva">
          <div className="grid">
            <div className="flex col-12 md:col-4 ">
              <label
                htmlFor="fechaReunionAsamblea"
                className="mr-2"
                style={{ minWidth: "150px", textAlign: "left" }}
                required
              >
                Fecha reunión asamblea:
              </label>
              <div className="col">
                <Calendar
                  id="fechaReunionAsamblea"
                  name="fechaReunionAsamblea"
                  value={
                    validarDatos?.object?.fecReunionAsamblea
                      ? moment(validarDatos?.object?.fecReunionAsamblea).toDate()
                      : ""
                  }
                  dateFormat="dd/mm/yy"
                  disabled
                  showIcon
                  style={{ width: "100%" }}
                />
              </div>
            </div>
            <div className="flex col-12 md:col-4 ">
              <label
                htmlFor="socios"
                className="mr-2"
                style={{ minWidth: "120px", textAlign: "left" }}
                required
              >
                Número de socios:
              </label>
              <div className="col">
                <InputNumber
                  id="socios"
                  name="socios"
                  value={validarDatos?.object?.numSocios ?? null}
                  autoComplete="off"
                  maxFractionDigits={0}
                  useGrouping={false}
                  disabled
                  style={{ width: "100%" }}
                />
              </div>
            </div>
            <div className="flex col-12 md:col-4 ">
              <label
                htmlFor="periodo"
                className="mr-2"
                style={{ minWidth: "150px", textAlign: "left" }}
                required
              >
                Período representantes:
              </label>
              <div className="col">
                <InputText
                  id="periodo"
                  name="periodo"
                  value={validarDatos?.object?.periodo ?? ""}
                  autoComplete="off"
                  disabled
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </div>
        </Fieldset>
        <div className="m-3"></div>
        <Fieldset legend="Datos adicionales">
          <div className="grid">
            <div className="flex col-12 md:col-6 ">
              <label
                htmlFor="objetoSocial"
                className="mr-2"
                style={{ minWidth: "150px", textAlign: "left" }}
                required
              >
                Objeto social:
              </label>
              <div className="col">
                <InputTextarea
                  id="objetoSocial"
                  name="objetoSocial"
                  value={validarDatos?.object?.objetoSocial}
                  autoComplete="off"
                  rows={2}
                  disabled
                  style={{ width: "100%" }}
                />
              </div>
            </div>
            <div className="flex col-12 md:col-4 ">
              <label
                htmlFor="capitalSocial"
                className="mr-2"
                style={{ minWidth: "140px", textAlign: "left" }}
                required
              >
                Capital social inicial:
              </label>
              <div className="col">
                <InputNumber
                  id="capitalSocial"
                  name="capitalSocial"
                  value={validarDatos?.object?.capitalSocial ?? null}
                  autoComplete="off"
                  useGrouping={false}
                  maxFractionDigits={2}
                  minFractionDigits={2}
                  min={0}
                  disabled
                  style={{ width: "100%" }}
                />
              </div>
            </div>

            {validarDatos?.object?.nemTipoSolicitud === nemonicoTipoSolicitud.ADECUACION && (
              <>
                <div className="col-12 md:col-8 ">
                  <label htmlFor="documentoPersonalidadJuridica" required>
                    Código de documento que otorgó personalidad jurídica:
                  </label>
                  <div className="col">
                    <InputTextarea
                      id="documentoPersonalidadJuridica"
                      name="documentoPersonalidadJuridica"
                      value={validarDatos?.object?.codDocuPerJurid ?? ""}
                      autoComplete="off"
                      rows={2}
                      disabled
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
                <div className="col-12 md:col-3 ">
                  <label htmlFor="fechaDocumento" required>
                    Fecha de documento:
                  </label>
                  <div className="col">
                    <Calendar
                      id="fechaDocumento"
                      name="fechaDocumento"
                      value={
                        validarDatos?.object?.fecDocumento
                          ? moment(validarDatos?.object?.fecDocumento).toDate()
                          : ""
                      }
                      dateFormat="dd/mm/yy"
                      showIcon
                      disabled
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
                <div className="col-12 md:col-8 ">
                  <label htmlFor="institucionPersonalidadJuridica" required>
                    Institución que otorgó personalidad jurídica:
                  </label>
                  <div className="col">
                    <InputTextarea
                      id="institucionPersonalidadJuridica"
                      name="institucionPersonalidadJuridica"
                      value={validarDatos?.object?.instPerJurid ?? ""}
                      autoComplete="off"
                      rows={2}
                      disabled
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
                <div className="col-12 md:col-3 ">
                  <label htmlFor="fechaDocumento" className="mr-2" required>
                    Fecha de convocatoria a asamblea de órgano de gobierno:
                  </label>
                  <div className="col">
                    <Calendar
                      id="fechaConvocatoria"
                      name="fechaConvocatoria"
                      value={
                        validarDatos?.object?.fecConvotoria
                          ? moment(validarDatos?.object?.fecConvotoria).toDate()
                          : ""
                      }
                      dateFormat="dd/mm/yy"
                      showIcon
                      disabled
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </Fieldset>
      </div>
    </>
  );
};
export default RevisarEntidadConstitución;
